/**
 * Component for rendering chicklets showing commissions insights.
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment'; 
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Grid } from '@mui/material';
import TextWidget from '../ui/TextWidget';
import TextWidgetUnsized from '../ui/TextWidgetUnsized';

import ServerError from '../ui/ServerError';
import LoadingSpinner from '../ui/LoadingSpinner';

const abEnvironment = new AbEnvironment();
const RcpCommViewQuery = graphql`
query RcpCommViewQuery($resellerPId: UUID!) {
  getpartnercommissionprogramsummary(resellerpid: $resellerPId) {
    resellerPId
    commProgramName
    partnerId
    partnerName
    cpId
    vendorId
    vendorName
    totalAmtPaid
    amtPending
  }
}
 `;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
    },
    flex: {
      flex: 1,
    },
    paper: {
      padding: theme.spacing(3),
      textAlign: 'left',
      color: theme.palette.text.secondary,
      maxWidth: 980,
      marginTop: 16
    },
    tblHead: {
      backgroundColor: '#f1f1f1'
    }
  });
  
class RcpCommView extends Component {
  state = {
    apps: null
  }

  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  goBack() {
    this.props.history.goBack();
  }

  render() {
    const { isAuthenticated, isAuthenticatedReseller, needAssent, logError } = this.props.auth;
    // const classes = this.props.classes;

    if (!isAuthenticated() || needAssent()) {
      return (
        <Redirect to='/home' />
      );
    } else if (isAuthenticatedReseller()) {

      let resellerPId = this.props.resellerPId;

      let tceDescription = 'Total commissions earned';
      let tceTooltip = 'Total commissions earned';
      let cpaDescription = 'Commissions pending';
      let cpaTooltip = 'Commissions pending approval';

      if (resellerPId == null) {
        // return an empty program
        let tceString = Number(0).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
        let cpaString = Number(0).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});

        return (
          <Grid container spacing={2} direction="column" justifyContent="flex-start">
            <Grid item>
              <TextWidgetUnsized
                value={tceString}
                description={tceDescription}
                tooltip={tceTooltip}
              />
           </Grid>
            <Grid item>
              <TextWidgetUnsized
                value={cpaString}
                description={cpaDescription}
                tooltip={cpaTooltip}
              />
            </Grid>
          </Grid>
        );
      }
      return (
        <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={RcpCommViewQuery}
          variables={{resellerPId: resellerPId}}
          render={({error, props})=> {
            if (error) {
              logError(error.message);
              return (
                <ServerError/>
              );
            } else if (props) {
              let totalAmtPaid = props.getpartnercommissionprogramsummary.totalAmtPaid;
              let amtPending   = props.getpartnercommissionprogramsummary.amtPending;

              let tceString = Number(totalAmtPaid).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
              let cpaString = Number(amtPending).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});

              return (
                <Grid container spacing={2} direction="column" >
                  <Grid item>
                    <TextWidgetUnsized
                      value={tceString}
                      description={tceDescription}
                      tooltip={tceTooltip}
                    />
                  </Grid>
                  <Grid item>
                    <TextWidgetUnsized
                      value={cpaString}
                      description={cpaDescription}
                      tooltip={cpaTooltip}
                    />
                  </Grid>
                </Grid>
              );
            }
            return <LoadingSpinner />
          }}
        />
      )
    } else {
      return (
        <Redirect to='/home' />
      );
    }
  }
}

RcpCommView.propTypes = {
    classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(RcpCommView);
